/**
 * JDM K24A RBB Landing Page — JS
 * Uses class selectors (NOT id) — Shopify strips id attributes in sections.
 */

(function () {
  'use strict';

  /* ======================================
     Image Gallery — Hero & Offer sections
     ====================================== */
  function initGalleries() {
    // Hero gallery
    setupGallery('k24HeroMain', '.k24-hero__thumb');
    // Offer gallery
    setupGallery('k24OfferMain', '.k24-offer__thumb');
  }

  function setupGallery(mainId, thumbSelector) {
    var main = document.getElementById(mainId);
    if (!main) return;

    var thumbs = document.querySelectorAll(thumbSelector);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = this.getAttribute('data-full');
        if (full && main) {
          main.style.opacity = '0.6';
          main.src = full;
          main.onload = function () { main.style.opacity = '1'; };
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ======================================
     FAQ Accordion
     ====================================== */
  function initFAQ() {
    var items = document.querySelectorAll('.k24-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.k24-faq-item__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Close all
        items.forEach(function (i) { i.classList.remove('open'); });
        // Toggle clicked
        if (!isOpen) item.classList.add('open');
      });
    });
    // Open first by default
    if (items.length) items[0].classList.add('open');
  }

  /* ======================================
     Smooth Scroll for anchor links
     ====================================== */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#k24-"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ======================================
     Scroll-reveal animations
     ====================================== */
  function initReveal() {
    var style = document.createElement('style');
    style.textContent = [
      '.k24-reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }',
      '.k24-reveal.visible { opacity: 1; transform: none; }'
    ].join('');
    document.head.appendChild(style);

    var targets = document.querySelectorAll(
      '.k24-review-card, .k24-pillar, .k24-stat-card, .k24-faq-item, .k24-purchase-card'
    );
    targets.forEach(function (el) { el.classList.add('k24-reveal'); });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('visible'); });
    }
  }

  /* ======================================
     Sticky mobile CTA bar
     ====================================== */
  function initStickyCTA() {
    var bar = document.createElement('div');
    bar.style.cssText = [
      'position:fixed;bottom:0;left:0;right:0;z-index:9999;',
      'background:#D62828;padding:12px 20px;',
      'display:flex;align-items:center;justify-content:space-between;gap:12px;',
      'transform:translateY(100%);transition:transform 0.3s ease;',
      'box-shadow:0 -4px 20px rgba(0,0,0,0.2);'
    ].join('');
    bar.innerHTML = [
      '<div style="color:#fff;font-family:Poppins,sans-serif;font-size:13px;font-weight:600;line-height:1.3;">',
      '  <strong style="font-size:18px;font-family:Epilogue,sans-serif;display:block;">$999</strong>',
      '  JDM K24A RBB Engine',
      '</div>',
      '<a href="#k24-offer" style="',
      '  background:#fff;color:#D62828 !important;font-weight:800;',
      '  padding:10px 24px;border-radius:6px;font-size:15px;',
      '  font-family:Epilogue,sans-serif;text-decoration:none;white-space:nowrap;',
      '  display:inline-flex;align-items:center;gap:6px;',
      '">Get It →</a>'
    ].join('');

    document.body.appendChild(bar);

    var hero = document.querySelector('.k24-hero');
    var offer = document.querySelector('#k24-offer');
    var visible = false;

    window.addEventListener('scroll', function () {
      var scrolled = window.scrollY > 300;
      var pastOffer = offer && window.scrollY > (offer.offsetTop - window.innerHeight + 100);
      var shouldShow = scrolled && !pastOffer;

      if (shouldShow !== visible) {
        visible = shouldShow;
        bar.style.transform = visible ? 'translateY(0)' : 'translateY(100%)';
      }
    }, { passive: true });

    // Smooth click
    bar.querySelector('a').addEventListener('click', function (e) {
      var target = document.querySelector('#k24-offer');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  }

  /* ======================================
     Init on DOM ready
     ====================================== */
  function init() {
    initGalleries();
    initFAQ();
    initSmoothScroll();
    initReveal();

    // Only show sticky mobile CTA on small screens
    if (window.innerWidth < 1024) {
      initStickyCTA();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
